module.exports = __webpack_public_path__ + "Flama-MediumItalic.woff?e8a7b6594dc748726867d4edc0b71dc4";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-MediumItalic.woff
// module id = 891
// module chunks = 0